// 语言切换：中文 / English / 한국어 三选一（全站唯一语言入口，币种跟随语言）。
import { useState } from 'react';
import { Chip, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { Check } from '@mui/icons-material';
import { usePrefs } from '@/store/BuyerPrefsContext';
import { LANGS, LANG_LABELS, tr, type Lang } from '@/i18n';

/** chip 上的简写：与原「中文 / EN」切换钮同尺寸，菜单里再显示完整语言名 */
const SHORT: Record<Lang, string> = { zh: '中文', en: 'EN', ko: 'KO' };

interface LangSwitcherProps {
  sx?: SxProps<Theme>;
  /** 切换后的额外回调（分享页需要把语言写回地址栏） */
  onChange?: (lang: Lang) => void;
}

export default function LangSwitcher({ sx, onChange }: LangSwitcherProps) {
  const { lang, setLang } = usePrefs();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const choose = (next: Lang) => {
    setAnchor(null);
    if (next === lang) return;
    setLang(next);
    onChange?.(next);
  };
  return (
    <>
      <Chip
        size="small"
        label={SHORT[lang]}
        aria-label={tr('lang.switch')}
        aria-haspopup="menu"
        aria-expanded={anchor ? 'true' : undefined}
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={[{ borderRadius: '9px', height: 34, minWidth: 48, fontSize: '12px', cursor: 'pointer' }, ...(Array.isArray(sx) ? sx : [sx])]}
      />
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { mt: .75, minWidth: 150, borderRadius: '12px' } } }}
      >
        {LANGS.map((code) => (
          <MenuItem key={code} selected={code === lang} onClick={() => choose(code)} lang={code}>
            <ListItemText primaryTypographyProps={{ fontSize: 14 }}>{LANG_LABELS[code]}</ListItemText>
            <ListItemIcon sx={{ minWidth: 0, ml: 2, color: '#059669', visibility: code === lang ? 'visible' : 'hidden' }}><Check fontSize="small" /></ListItemIcon>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
